import { GetServerSidePropsContext } from 'next';
import { NextPage } from 'next';
import React from 'react';
import { cachedFetchPurchases } from '../../api/fetchPurchases';
import { PurchasesResponse } from '../../api/fetchPurchases';
import { AnnouncesIndexQuery } from '../../api/fetchPurchases';
import { useBreadcrumbs } from '../../components/_shared/Breadcrumbs/BreadcrumbsContext';
import { LayoutEmbed } from '../../components/LayoutEmbed';
import { Purchases } from '../../components/Purchases';
import { Services } from '../../types';

const PurchasesEmbedPage: NextPage<PurchasesResponse> & {
    LayoutComponent: React.ComponentType;
} = ({
    announces,
    reference,
    orgSection,
    total,
    matches,
    selectableOptions,
}) => {
    useBreadcrumbs([{ title: 'закупки' }]);

    return (
        <Purchases
            announces={announces}
            reference={reference}
            orgSection={orgSection}
            total={total}
            matches={matches}
            selectableOptions={selectableOptions}
        />
    );
};

export default PurchasesEmbedPage;

export const getServerSideProps = async (
    context: GetServerSidePropsContext<AnnouncesIndexQuery> & {
        req: { services: Services };
    }
) => {
    const props = await cachedFetchPurchases(
        context.query,
        context.req.services
    );
    return {
        props,
    };
};

PurchasesEmbedPage.LayoutComponent = LayoutEmbed;
